import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "@/hooks/use-toast";
import { useMyConsent, useWithdrawConsent, isActive } from "@/lib/concierge/consent";

export function ConsentWithdrawPanel({ siteId }: { siteId: string }) {
  const { data: consent } = useMyConsent(siteId);
  const withdraw = useWithdrawConsent();
  const [pending, setPending] = useState(false);

  return (
    <Card>
      <CardContent className="p-6 space-y-3">
        <div>
          <h2 className="text-base font-medium">Privacy & consent</h2>
          <p className="text-sm text-muted-foreground">
            {isActive(consent)
              ? "Activity recording is on. Your coach can see when you visit and which resources you open."
              : consent?.withdrawn_at
                ? "You've withdrawn consent. No new activity is being recorded."
                : "No consent recorded yet."}
          </p>
        </div>
        {isActive(consent) && (
          <div>
            <Button
              variant="outline"
              size="sm"
              disabled={pending}
              onClick={async () => {
                if (!window.confirm("Stop recording your activity on this page?")) return;
                setPending(true);
                try {
                  await withdraw.mutateAsync(siteId);
                  toast({ title: "Consent withdrawn" });
                } catch (e: any) {
                  toast({ title: "Failed", description: e.message, variant: "destructive" });
                } finally {
                  setPending(false);
                }
              }}
            >
              Withdraw consent
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
}

export default ConsentWithdrawPanel;
